export const CONFIG_SWITCHER_MIN_LEVEL = 5;
export const BRAND_PRIORITY_EDIT_MIN_LEVEL = 7;
export const FULL_NAV_LEVEL = 8;
export const SUPER_ADMIN_LEVEL = 9;

/** Human-readable labels for access levels. Levels 5, 7, 8, 9 are the thresholds in use. */
export const ACCESS_LEVEL_LABELS: { value: string; name: string }[] = [
	{ value: '1', name: '1 – Restricted (menu by permission only)' },
	{ value: '2', name: '2 – Limited' },
	{ value: '3', name: '3 – Standard' },
	{ value: '4', name: '4 – Extended' },
	{ value: '5', name: '5 – Can switch assigned setups' },
	{ value: '6', name: '6 – Elevated' },
	{ value: '7', name: '7 – Can edit brand priorities' },
	{ value: '8', name: '8 – Manager (full menu access)' },
	{ value: '9', name: '9 – Full admin (sees all setups, remove locations)' }
];

export function getAccessLevelName(value: string): string {
	const level = ACCESS_LEVEL_LABELS.find(l => l.value === value);
	return level ? level.name : (value || '—');
}

export function userLevelAtLeast(user: { user?: { fullaccess?: string | number } } | null, minLevel: number): boolean {
	const level = user?.user?.fullaccess != null ? parseInt(String(user.user.fullaccess), 10) : NaN;
	return !Number.isNaN(level) && level >= minLevel;
}

export function isSuperAdmin(user: { user?: { fullaccess?: string | number } } | null): boolean {
	return userLevelAtLeast(user, SUPER_ADMIN_LEVEL);
}
